module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Select from library":"Aus Mediathek wählen","Remove file":"Datei entfernen","Download file":"Datei herunterladen","Files belong to the ticket. Files sent in the correspondence stay with their message.":"Dateien gehören zum Ticket. In der Korrespondenz versendete Dateien bleiben bei ihrer Nachricht."}}')
  delete Component.options._Ctor
}
